import { render, staticRenderFns } from "./renstra_sasaran.vue?vue&type=template&id=b56f96aa&"
import script from "./renstra_sasaran.vue?vue&type=script&lang=js&"
export * from "./renstra_sasaran.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports